import React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

const alertVariants = cva(
  [
    "relative w-full rounded-2xl border px-4 py-3 text-sm shadow-xl backdrop-blur-sm",
    "[&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:h-5 [&>svg]:w-5",
    "[&>svg+div]:pl-8",
  ].join(" "),
  {
    variants: {
      variant: {
        default: "border-border bg-card text-card-foreground",
        destructive: "border-destructive/50 bg-destructive/10 text-destructive dark:border-destructive/60",
        success: "border-success/40 bg-success/10 text-success",
        error: "border-destructive/50 bg-destructive/10 text-destructive",
        warning: "border-warning/40 bg-warning/10 text-warning",
        info: "border-info/40 bg-info/10 text-info",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export function Alert({ className = "", variant = "default", children, ...props }) {
  return (
    <div role="alert" className={cn(alertVariants({ variant }), className)} {...props}>
      {children}
    </div>
  );
}

export function AlertTitle({ className = "", children, ...props }) {
  return (
    <div className={cn("mb-1 font-semibold leading-none tracking-tight", className)} {...props}>
      {children}
    </div>
  );
}

export function AlertDescription({ className = "", children, ...props }) {
  return (
    <div className={cn("text-sm opacity-90 [&_p]:leading-relaxed", className)} {...props}>
      {children}
    </div>
  );
}

export function AlertAction({ className = "", children, ...props }) {
  return (
    <div
      className={cn(
        "absolute right-3 top-3 inline-flex items-center justify-center",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export default Alert;
